/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { EventMetadata, SendEventData } from '../types'

export class EventSenderPlugin {
  name: string

  constructor(name: string) {
    this.name = name
  }

  init() {}

  sendEvent(event: SendEventData) {}

  updateMetadata(metadata: EventMetadata) {}
}
